import { Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { showModal, useTable } from '../shared/components';
import GlobalizedText from '../shared/globalization';
import { useMessage } from "../shared/message";
import { ajax, validate } from '../shared/utils';
import { ViewComponentProps, withView } from '../shared/viewcomponent';
import * as yup from 'yup';
import { YupSchema } from '../shared/yupschema';
import './css/userinquiry.css';

interface RequestBodyDataType {
    followUpAction: string,
    inquiryID: 0,
    status: string,
    newAssignedTo?: string
}

const defaultStatusesByPA = ["New", "Processing", "Assigned"];
const defaultStatusesByCSR = ["New", "Processing", "Re-Assigned"];
const FLOWING_ACTION_MAX_LENGTH: number = 300;

export const UserInquiryComponent = withView((props: ViewComponentProps) => {

    const [config, setConfig] = useState<any>();
    const [userList, setUserList] = useState<Array<any>>([]);
    const [userInquiries, setUserInquiries] = useState<Array<any>>([]);
    // const [userInquiries2, setUserInquiries2] = useState<Array<any>>([]);
    const [selectedInquiries, setSelectedInquiries] = useState<Array<string>>([]);
    const [selectedUser, setSelectedUser] = useState<string>();
    const message = useMessage("userInquiryDialog");
    const [singleUserInquiry, setSingleUserInquiry] = useState<any>();
    const [count, setCount] = useState<number>(0);
    const [currentTablePage, setCurrentTablePage] = useState<number>();
    const [currentStatus, setCurrentStatus] = useState<Array<any>>([]);

    let requestBody4ChangeAssignOwner: Array<RequestBodyDataType> = []
    let requestBody4UpdateUserInquiry: RequestBodyDataType = {
        followUpAction: '',
        inquiryID: 0,
        status: ''
    }
    const followUpActionSchema = yup.object().shape({
        followUpAction: YupSchema.followUpAction
    });

    useEffect(() => {
        if (config === undefined) {
            ajax({
                url: '/api/userInquiry/view',
                success: (res: any) => {
                    setConfig(res);
                    if (res.showChangeAssignedOwner === true) {
                        setCurrentStatus(defaultStatusesByPA)
                    }
                    if (res.showChangeAssignedOwner === false) {
                        setCurrentStatus(defaultStatusesByCSR)
                    }
                    loadAllInquiries();
                    if (res.showChangeAssignedOwner === true) {
                        loadAllUserList();
                    }
                }
            });
        }
    }, [config]);

    useEffect(() => {
        if (singleUserInquiry !== undefined) {
            props.clearMessage();
            props.showModal("#processingSingleInquiryDialog")
        }
    }, [count, singleUserInquiry])

    useEffect(() => {
        loadAllInquiries();
    }, [currentStatus])

    function loadAllUserList() {
        ajax({
            url: '/api/userInquiry/getAllGroupUsers',
            success: (res2: any) => {
                setUserList(res2);
            }
        });
    }

    function loadAllInquiries() {
        ajax({
            url: '/api/userInquiry/getAllContactForms',
            success: (res: Array<any>) => {
                if (res != null) {
                    // setUserInquiries2(res);
                    setUserInquiries(res);
                }
            }
        })
    }
    //rebuild requestBody
    function changeAssignedOwner() {
        requestBody4ChangeAssignOwner = [];
        selectedInquiries.forEach((row: any) => {
            let tmp: RequestBodyDataType = {
                followUpAction: row.followUpAction,
                inquiryID: row.inquiryID,
                status: row.status,
                newAssignedTo: selectedUser
            }
            requestBody4ChangeAssignOwner.push(tmp)
        })
        if (requestBody4ChangeAssignOwner.length > 0) {
            ajax({
                url: '/api/userInquiry/assignInquiry',
                data: requestBody4ChangeAssignOwner,
                method: 'POST',
                success: () => {
                    loadAllInquiries()
                    setCurrentTablePage(userInquiryLists.page());
                    setSelectedUser(undefined)
                    userInquiryLists.selectAll(false)
                    props.showMessage("success", props.getGlobalizedText("common.msg.updateSuccess"));
                }
            })
        }
    }

    function updateUserInquiry(values: any, formProps: any) {
        requestBody4UpdateUserInquiry = {
            followUpAction: values.followUpAction,
            inquiryID: singleUserInquiry.inquiryID,
            status: values.status
        }
        ajax({
            url: '/api/userInquiry/updateInquiry',
            data: requestBody4UpdateUserInquiry,
            method: 'POST',
            success: () => {
                setCurrentTablePage(userInquiryLists.page())
                props.closeModal("#processingSingleInquiryDialog")
                formProps.resetForm();
                loadAllInquiries()
            }, fail: () => { }
        })
    }

    const userLists = useMemo(() => useTable({
        modal: "viewInquiryDialog",
        id: "changeAssignedOwnerTable",
        option: { paging: false, scrollCollapse: true },
        select: {
            type: 'single', prefix: 'users_', onSelect: (e: any, rows: number[]) => {
                if (rows.length > 0) {
                    setSelectedUser(userList[rows[0]].userID);
                } else {
                    setSelectedUser(undefined);
                }
            }
        },
        table: {
            columns: [
                { title: "common.lbl.name", name: "name" },
                { title: "pd.lbl.email", name: "email" },
            ], data: userList
        }
    }), [userList]);

    const userInquiryLists = useMemo(() => {
        let count1: number = 0;
        return useTable({
            select: (config !== undefined && config.showChangeAssignedOwner) ? {
                type: "multiple", prefix: "inquiry_", onSelect: (e: any, rows: Array<number>) => {
                    let tmp: string[] = [];
                    rows.forEach((row) => {
                        tmp.push(userInquiries[row]);
                    });
                    setSelectedInquiries(tmp);
                }
            } : undefined,
            id: "userInquiryTable",
            dateformat: props.getDateFormat(),
            delayAdjust: true,
            table: {
                columns: [
                    {
                        title: "common.lbl.name", name: "firstName",
                        onClick: (e: any, row: any) => {
                            if (row.status !== "Re-Assigned") {
                                openUpdateUserInquiryDialog(row, count1++)
                            }
                        },
                        render: (data: any, type: any, row: any, meta: any) => { if (row.status !== "Re-Assigned") { return `<a >${row.name}</a>` } else { return `${row.name}` } }
                    },
                    { title: "common.lbl.questions", name: "question" },
                    { title: "common.lbl.submitDate", name: "displayCreatedDate", type: 'date' },
                    { title: "security.lbl.userType", name: "userType" },
                    { title: "common.lbl.assignedOwner", name: "assignedTo" },
                    { title: "common.lbl.status", name: "status" },
                ],
                data: userInquiries
            },
            onRendered: () => {
                if (config !== undefined && currentStatus !== undefined) {
                    if (config.showChangeAssignedOwner === true) {
                        userInquiryLists.filter(7, currentStatus, true, false)
                        userInquiryLists.page(currentTablePage)
                    } else {
                        userInquiryLists.filter(6, currentStatus, true, false)
                        userInquiryLists.page(currentTablePage)
                    }
                }
            }
        })
    }, [userInquiries]);

    const userListTable = useMemo(() => <userLists.Component />, [userLists]);
    const userInquiryTable = useMemo(() => <userInquiryLists.Component />, [userInquiryLists]);
    const viewInquiryDialog = useMemo(() => <Formik initialValues={{ searchUser: "" }} onSubmit={() => {
    }}>
        {formProps =>
            <props.Modal messageService={message.messageService} title="common.lbl.changeAssignedOwner" id="viewInquiryDialog" footer={() => {
                return <>
                    <props.Button onClick={() => {
                        if (selectedUser === undefined) { message.validateProps.showMessage("error", "common.msg.assigneeRequired"); }
                        else { changeAssignedOwner(); formProps.resetForm(); props.closeModal("#viewInquiryDialog"); message.validateProps.clearMessage(); userLists.filter(2, "", true, false) }
                    }} className="btn btn-primary gwp-btn"><GlobalizedText message="common.lbl.ok" /></props.Button>
                    <props.Button data-dismiss="modal" onClick={() => { message.validateProps.clearMessage(); formProps.resetForm(); userLists.filter(2, "", true, false) }} ><GlobalizedText message="common.lbl.close" /></props.Button>
                </>
            }}>
                <props.Row>
                    <props.Col sm="12">
                        <props.ComboboxControl hiddenLabel="searchUsers" hiddenLabelFor="searchUsers_input" name="searchUsers" onChange={(v: string) => {
                            userLists.filter(2, v.trim(), true, false);
                        }} onValueChange={(val: string) => { return userList.filter((user: any) => { return user.name.toLowerCase().startsWith(val.toLowerCase()) }).map((user: any) => { return user.name }) }}></props.ComboboxControl>
                    </props.Col>
                </props.Row>
                <props.Div style={{ maxHeight: 400, overflowY: "auto", overflowX: "hidden" }}>
                    {userListTable}
                </props.Div>
            </props.Modal >
        }
    </Formik >, [userListTable, userLists, selectedUser])

    const openUpdateUserInquiryDialog = (row: any, count1: number) => {
        let tmp = userInquiries.find((value: any, index: number) => { return value.inquiryID === row.inquiryID })
        setSingleUserInquiry(tmp)
        setCount(count1)

    }

    function verifyInquiryStatus() {
        let countClosedStatus: number = 0
        selectedInquiries.some((row: any) => {
            if (row.status === "Closed") {
                countClosedStatus = 1
                return true
            }
        })
        if (countClosedStatus === 0) {
            props.showModal("#viewInquiryDialog")
        } else {
            props.showModal("#assignClosedInquiries")
        }
    }

    if (config === undefined) {
        return <></>
    }

    return <props.Div id="userinquiry">
        <props.Row>
            <props.Col sm="12" md="12" xs="12">
                <props.Button condition={config.showChangeAssignedOwner === true} disabled={selectedInquiries.length === 0} className="btn btn-primary gwp-btn" onClick={() => { userLists.selectAll(false); verifyInquiryStatus() }}><GlobalizedText message="common.lbl.changeAssignedOwner" /></props.Button>
                {(config.showChangeAssignedOwner === true && currentStatus !== undefined) &&
                    <props.SelectButton defaultValue={defaultStatusesByPA} onValueChange={(values: Array<string>) => {
                        if (values.length !== 0) {
                            setCurrentStatus(values); userInquiryLists.filter(7, values.length === 0 ? ['no'] : values, true, false); userInquiryLists.selectAll(false);
                        } else {
                            props.clearMessage();
                            showModal("#alertDialog");
                            userInquiryLists.filter(7, 'no', true, false)
                        }
                    }}
                        label="common.lbl.status" buttons={config.statuses.map((status: string) => { return { name: status, value: status } })} />
                }
                {(config.showChangeAssignedOwner === false && currentStatus !== undefined) &&
                    < props.SelectButton defaultValue={defaultStatusesByCSR} onValueChange={(values: Array<string>) => {
                        if (values.length !== 0) {
                            setCurrentStatus(values); userInquiryLists.filter(6, values.length === 0 ? ['no'] : values, true, false); userInquiryLists.selectAll(false);
                        } else {
                            props.clearMessage();
                            showModal("#alertDialog");
                            userInquiryLists.filter(6, 'no', true, false)
                        }
                    }} label="common.lbl.status" buttons={config.statuses.map((status: string) => { return { name: status, value: status } })} />
                }
            </props.Col>
        </props.Row >
        {/**User Inquiry table */}
        {userInquiryTable}

        {/** User Inquiry dialog */}
        {config.showChangeAssignedOwner === true &&
            viewInquiryDialog
        }

        {/** process Inquiry Dialog */}
        {singleUserInquiry !== undefined &&
            // processingUserInquiry
            <Formik
                initialValues={{
                    status: singleUserInquiry.status,
                    followUpAction: singleUserInquiry.followUpAction
                }}
                validateOnBlur={false}
                validateOnChange={false}
                enableReinitialize={true}
                onReset={props.clearMessage}
                validate={values => {
                    return validate(followUpActionSchema, values, props);
                }}
                onSubmit={(values, formProps) => {
                    // formProps.resetForm();
                    updateUserInquiry(values, formProps)
                }
                }
            >
                {formProps =>
                    <Form>
                        <props.Modal title={singleUserInquiry.status !== "Closed" ? "common.lbl.processUserInquiry" : "common.lbl.viewUserInquiry"} id="processingSingleInquiryDialog" messageService={props.messageService} footer={() => {
                            return <>
                                <props.Button condition={singleUserInquiry.status !== "Closed"} type="submit"><GlobalizedText message="common.lbl.save" /></props.Button>
                                <props.Button onClick={() => { props.closeModal("#processingSingleInquiryDialog"); formProps.resetForm() }}><GlobalizedText message="common.lbl.close" /></props.Button>
                            </>
                        }}>
                            <props.Row>
                                <props.Col sm="6" md="6" xs="6">
                                    <props.DL>
                                        <props.DLI title="common.lbl.firstName" desc={singleUserInquiry.firstName}></props.DLI>
                                        <props.DLI title="common.lbl.lastName" desc={singleUserInquiry.lastName}></props.DLI>
                                        <props.DLI title="pd.lbl.phone" desc={singleUserInquiry.contactPhone}></props.DLI>
                                        <props.DLI title="pi.email.address" desc={singleUserInquiry.contactEmail}></props.DLI>
                                    </props.DL>
                                </props.Col>
                                <props.Col sm="6" md="6" xs="6">
                                    <props.DL>
                                        <props.DLI title="common.lbl.question" desc={singleUserInquiry.question}></props.DLI>
                                        <props.DLI title="common.lbl.assignedDate" condition={singleUserInquiry.status !== "Closed"} desc={singleUserInquiry.displayAssignedDate}></props.DLI>
                                        <props.DLI condition={singleUserInquiry.status === "Closed"} title="common.lbl.status" desc={singleUserInquiry.status}></props.DLI>
                                        <props.DLI condition={singleUserInquiry.status === "Closed"} title="common.lbl.closedDate" desc={singleUserInquiry.displayUpdatedDate}></props.DLI>
                                        <props.DLI condition={singleUserInquiry.status === "Closed"} title="common.lbl.assignedOwner" desc={singleUserInquiry.assignedTo}></props.DLI>
                                        <props.DLI condition={singleUserInquiry.status === "Closed"} title="common.lbl.followupAction" desc={() => {
                                            return <props.Div id="followActionClosed" className="followActionClosed">
                                                {singleUserInquiry.followUpAction}
                                            </props.Div>
                                        }}></props.DLI>
                                    </props.DL>

                                    <props.SelectControl condition={(config.showChangeAssignedOwner === true && singleUserInquiry.status !== "Closed")} sort={false} style={{ width: "60%" }} name="status" label="common.lbl.status" options={[{ name: singleUserInquiry.status, value: singleUserInquiry.status }, { name: "Closed", value: "Closed" }]} onChange={(e: any) => formProps.setFieldValue("status", e.target.value)} ></props.SelectControl>
                                    <props.SelectControl condition={(config.showChangeAssignedOwner === false && singleUserInquiry.status === "Processing")} sort={false} style={{ width: "60%" }} name="status" label="common.lbl.status" options={[{ name: singleUserInquiry.status, value: singleUserInquiry.status }, { name: "Closed", value: "Closed" }]} onChange={(e: any) => formProps.setFieldValue("status", e.target.value)} ></props.SelectControl>
                                    <props.SelectControl condition={(config.showChangeAssignedOwner === false && singleUserInquiry.status !== "Closed" && singleUserInquiry.status !== "Processing")} sort={false} style={{ width: "60%" }} name="status" label="common.lbl.status" options={[{ name: singleUserInquiry.status, value: singleUserInquiry.status }, { name: "Processing", value: "Processing" }, { name: "Closed", value: "Closed" }]} onChange={(e: any) => formProps.setFieldValue("status", e.target.value)} ></props.SelectControl>

                                    <props.TextareaControl condition={singleUserInquiry.status !== "Closed"} style={{ width: "60%" }} maxLength={FLOWING_ACTION_MAX_LENGTH} label="common.lbl.followupAction" name="followUpAction" showRemaining={true} required={true}></props.TextareaControl>
                                </props.Col>
                            </props.Row>
                        </props.Modal>
                    </Form>
                }
            </Formik>
        }

        {/**Error Modal. Please select one status */}
        < props.Modal id="alertDialog" footer={() => {
            return <>
                <props.Button data-dismiss="modal"><GlobalizedText message="common.lbl.close" /></props.Button>
            </>
        }}>
            <props.Row>
                <props.Col sm="12" md="12" xs="12">
                    <props.Div className="alert alert-warning">
                        <props.H5>
                            <props.Span className="gwp-icon gwp-icon-warning gwp-icon-sm">
                            </props.Span>
                            <GlobalizedText message="common.msg.itemRequired"></GlobalizedText>123
                        </props.H5>
                    </props.Div>
                </props.Col>
            </props.Row>
        </props.Modal >
        {/* ChangeAssingedOwner by status === Closed */}
        < props.Modal id="assignClosedInquiries" footer={() => {
            return <>
                <props.Button data-dismiss="modal"><GlobalizedText message="common.lbl.close" /></props.Button>
            </>
        }}>
            <props.Row>
                <props.Col sm="12" md="12" xs="12">
                    <props.Div className="alert alert-warning">
                        <props.H5>
                            <props.Span className="gwp-icon gwp-icon-warning gwp-icon-sm"></props.Span>{" "}
                            <GlobalizedText message="common.msg.canNotBeChange"></GlobalizedText>
                        </props.H5>
                    </props.Div>
                </props.Col>
            </props.Row>
        </props.Modal >

    </props.Div>
});
